import { Middleware } from 'redux';
import { rootReducerMap } from '../reducers/index';
import { AppState } from '../types/store';
import { rootModuleStoreFactory } from '@wix/da-shared-react/pkg/redux/rootModuleStore/factory';
import { IModuleStore } from 'redux-dynamic-modules-core';

import rootSaga from '../sagas';
import logger from '../helpers/logger';

export function configureStore(initialState: AppState): IModuleStore<AppState> {
  const middleware: Middleware[] = [];

  return rootModuleStoreFactory<AppState>(
    middleware,
    logger,
    initialState,
    rootReducerMap,
    rootSaga,
    false
  ) as IModuleStore<AppState>;
}
